/* eslint-disable no-alert */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AlertDialog, Field, Box, Input, Textarea } from '@components/design-system';
import { AvatarEdit } from '@components/modals/avatar-edit';
import { CoverEdit } from '@components/modals/cover-edit';
import * as Styles from '@components/modals/styles';
import { IUploadImage } from '@interface/media';
import { actions } from '@state/auth';
import { RootState } from '@state/store';
import { getURLFromIPFSorHTTP } from '@utils/ipfs';

export interface IProfileEdit {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  // callback?: (result?: any) => void;
}

export const ProfileEdit: FC<IProfileEdit> = ({ open, onOpenChange }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((e: RootState) => e.auth);

  const [name, setName] = useState(user?.screen_name || '');
  const [bio, setBio] = useState(user?.profile_bio || '');
  const [avatar, setAvatar] = useState<IUploadImage>();
  const [cover, setCover] = useState<IUploadImage>();

  const handleConfirm = async () => {
    dispatch({ type: actions.AUTH_UPDATE_PROFILE, payload: { name, bio, avatar, cover } });

    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  return (
    <AlertDialog title="Edit Profile" open={open} onConfirm={handleConfirm} onCancel={handleCancel}>
      <Styles.Content>
        <Box
          css={{
            position: 'relative',
            flex: 'none',
            width: '100%',
            height: 128,
            marginBottom: -32,
          }}
        >
          <CoverEdit
            path={cover?.blob || getURLFromIPFSorHTTP(user?.profile_banner_uri)}
            callback={(nextCover: IUploadImage) => setCover(nextCover)}
          />
        </Box>

        <Box
          css={{
            position: 'relative',
            flex: 'none',
            width: 64,
            height: 64,
            marginLeft: '$space$4',
            borderRadius: 9999,
            overflow: 'hidden',
            border: '2px solid $colors$primaryBackground',
          }}
        >
          <AvatarEdit
            name={user?.name || ''}
            path={avatar?.blob || getURLFromIPFSorHTTP(user?.profile_image_uri)}
            callback={(nextAvatar: IUploadImage) => setAvatar(nextAvatar)}
          />
        </Box>
        <Field uid="name" label="Name">
          <Input placeholder="Your Name" value={name} onChange={(value: string) => setName(value)} />
        </Field>
        <Field uid="bio" label="Bio">
          <Textarea placeholder="Your Bio" value={bio} onChange={(value: string) => setBio(value)} />
        </Field>
      </Styles.Content>
    </AlertDialog>
  );
};
